import Form   from "../../Lib/Forms/Form";
import Swatch from "./Swatch";

export default class SwatchForm extends Form {

    constructor() {
        super();
        this.swatch = {};
    }

    rules() {
        return {
            swatch: {
                color: {
                    red  : ['min:0', 'max:255'],
                    green: ['min:0', 'max:255'],
                    blue : ['min:0', 'max:255'],
                },
                name      : ['required'],
                id        : ['required', 'min:1'],
                palette_id: ['required', 'min:1'],
            }
        }
    }

    submit() {
        this.validate();
        if(this.validator.fails()) {
            return;
        }

        let swatch = new Swatch(this.swatch);

        let data = {
            color: {
                red  : swatch.color.red,
                green: swatch.color.green,
                blue : swatch.color.blue,
            },
            name : swatch.name,
        };

        return swatch.update(data);
    }

}
